module.exports = __webpack_public_path__ + "static/img/A74.05ecf302.jpg";